module.exports = __webpack_public_path__ + "static/media/mail.b986b4fd.svg";